"use strict";
exports.__esModule = true;
//# sourceMappingURL=investors-table.js.map